import React from 'react'
import './GroupNameHeader.css'
import * as FontAwesome from 'react-icons/lib/fa'

class GroupNameHeader extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      isEditing: false,
      isSaving: false,
      groupNameValue: this.props.groupName,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleRemoveGroup = this.handleRemoveGroup.bind(this)
  }

  handleSubmit (event) {
    const { groupId, handleGroupNameSubmit } = this.props
    event.preventDefault()
    handleGroupNameSubmit(groupId, this.state.groupNameValue);
    this.setState({ isEditing: false })
  }

  handleChange(event) {
    this.setState({ groupNameValue: event.target.value });
  }

  handleRemoveGroup () {
    const { groupId } = this.props
    this.props.handleDeleteGroup(groupId)
  }

  renderEditButtons () {
    const { groupName, balance } = this.props
    return (
      <div className="edit-buttons">
        {!this.state.isEditing && <button className="btn btn-light" onClick={() => this.setState({ isEditing: true })}>Edit</button>}
        { this.props.showDeleteButton && <button className="btn btn-danger" onClick={this.handleRemoveGroup}>X</button> }
      </div>
    )
  }

  renderGroupTitle () {
    const { groupName, balance } = this.props
    if (this.state.isEditing) {
      return (
        <form className="edit-title-form" onSubmit={this.handleSubmit}>
          <input className="form-control" type="text" value={this.state.groupNameValue} onChange={this.handleChange} />
          <input className="btn btn-success" type="submit" value="Save" />
        </form>
      )
    }

    return (
      <div className="title">
        <span className="">{groupName}</span>
      </div>
    )
  }

  render(props) {
    const { groupName, balance } = this.props
    return (
      <div className="panel">
        <div className="panel__inner">
          <h3 className="h2">
          {balance}

          </h3>
          <h4>
            {this.renderGroupTitle()}
            {this.renderEditButtons()}
          </h4>

        </div>
      </div>
    )
  }
}

export default GroupNameHeader



// WEBPACK FOOTER //
// ./src/components/GroupNameHeader/GroupNameHeader.js